<template>
    <div class="text-info-500">
        <p
            v-for="(item, index) in data"
            :key="index"
            class="leading-[41px] hover:text-info-700">
            <router-link :to="nextJourneyRoute(item)">
                {{ item.code }}
            </router-link>
            <br >
        </p>
    </div>
</template>
<script lang="ts" setup>
const props = defineProps({
  params: Object
})

const { params } = toRefs(props)

const data: any = ref()

onBeforeMount(() => {
  data.value = params?.value?.data.journeys || {}
})

const nextJourneyRoute = (item: any) => {
  if (!item) {
    return null
  }
  return {
    name: 'trucker-id-journey-management',
    query: { journeyId: item?._id, action: 'view' }
  }
}
</script>
